module.exports = __webpack_public_path__ + "static/anana-vestige-home-sitting-in-park-25d2cba6ad571b7294040b8bada0992b.png";